<div>
    <form [formGroup]="formGroup">
        <div class="mt-10 mb-15">
            <h4 class="pl-10">Heatmap image</h4>
            <app-attachments (submitField)="getAttachmentField($event)"
                             [commentType]="'image'"
                             [disable]="!!initialImage"
                             [hideTypeChoosing]="true"
                             [initialAttachment]="initialImage"></app-attachments>
        </div>

        <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label>Heatmap title</mat-label>
            <input formControlName="title" matInput>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100"
                        color="accent">
            <mat-label>Heatmap description</mat-label>
            <textarea formControlName="description"
                      matInput
                      maxlength="400" rows="4"></textarea>
        </mat-form-field>
        <div *ngFor="let option of options.controls; let i = index" class="pl-10" formArrayName="options">
            <h4>Option {{ i + 1 }}</h4>
            <div class="d-flex gap-10">
                <div class="d-flex justify-content-center color-picker-container" matPrefix>
                    <div (colorPickerChange)="onChangeColor($event, i)"
                         [colorPicker]="color.get(i)"
                         [style.background]="color.get(i)"
                         class="picker"></div>
                </div>
                <div [formGroupName]="i" class="flex-1">
                    <mat-form-field appearance="outline" class="w-100 noBottomPadding"
                                    color="accent">
                        <mat-label>Option text</mat-label>
                        <input formControlName="text" matInput>
                    </mat-form-field>
                </div>
                <div *ngIf="!initialImage" class="flex-row flex-space-evenly align-items-center" matSuffix>
                    <button (click)="removeOption(i)"
                            *ngIf="options.length >= 3"
                            class="icon"
                            mat-icon-button>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <button (click)="addOption()"
                            *ngIf="i === options.length - 1"
                            class="icon"
                            mat-icon-button>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row align-items-center gap-15 pt-10 mt-10 ">
            <mat-form-field appearance="outline" class="noBottomPadding" color="accent">
                <mat-label>Finish date</mat-label>
                <input [matDatepicker]="picker" formControlName="end_at" matInput>
                <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="noBottomPadding" color="accent">
                <mat-label>Number of votes</mat-label>
                <input formControlName="maximum_votes" matInput type="number">
                <mat-hint>The amount of times a user can vote on the heatmap defaults to 1</mat-hint>
            </mat-form-field>
        </div>
    </form>
</div>
